import { BoardServicesStateInterface } from '.';

function state(): BoardServicesStateInterface {
  return {
    boardServices: [],
  };
}

export default state;
